<template>
  <modal name="add-customer-modal" transition="pop-out"
         :width="800"
         :height="600">
    <h4 class="text-center panel-heading">Klant toevoegen</h4>
    <form @submit.prevent="addCustomer()">
      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>Debiteurnummer*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.debtorNumber">
          </div>
          <div class="col-sm-6 mb-20">
            <label>Bedrijfsnaam*</label>
            <input type="text"
                   required
                   class="form-control"
                   v-model="customer.companyName">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>Naam*</label>
            <input
              type="text"
              class="form-control"
              required
              v-model="customer.name">
          </div>
          <div class="col-sm-6 mb-20">
            <label>Kvk*</label>
            <input
              type="text"
              class="form-control"
              required
              v-model="customer.kvk">
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>Adres*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.address">
          </div>
          <div class="col-sm-6 mb-20">
            <label>Postcode*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.zipCode">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>Email*</label>
            <input
              type="email"
              class="form-control"
              required
              v-model="customer.email">
          </div>
          <div class="col-sm-6 mb-20">
            <label>Facturering email*</label>
            <input
              type="email"
              class="form-control"
              required
              v-model="customer.invoiceEmail">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>Plaatsnaam*</label>
            <input
              type="text"
              class="form-control"
              required
              v-model="customer.city">
          </div>
          <div class="col-sm-6 mb-20">
            <label>Telefoon*</label>
            <input
              type="text"
              class="form-control"
              required
              v-model="customer.phoneNumber">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>Land*</label>
            <input
              type="text"
              class="form-control"
              required
              v-model="customer.country">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-4">
            <button type="submit" class="btn btn-danger">Opslaan</button>
          </div>
        </div>
      </div>
    </form>
  </modal>
</template>
<script>
  import {mapGetters} from 'vuex'
  import * as types from '../../store/mutation-types'

  export default {
    name: 'AddCustomer',
    data () {
      return {
        customer: {
          debtorNumber: '',
          companyName: '',
          name: '',
          address: '',
          zipCode: '',
          city: '',
          kvk: '',
          phoneNumber: '',
          email: '',
          invoiceEmail: '',
          country: '',
          extraOrderMail: ''
        }
      }
    },
    methods: {
      addCustomer () {
        this.$store.commit(types.SET_CUSTOMER_TO_CREATE, this.customer)
        this.$store.dispatch('createCustomer').then(() => {
          if (this.isCustomerCreated) {
            this.customer.debtorNumber = ''
            this.customer.companyName = ''
            this.customer.address = ''
            this.customer.zipCode = ''
            this.customer.city = ''
            this.customer.kvk = ''
            this.customer.phoneNumber = ''
            this.customer.email = ''
            this.customer.invoiceEmail = ''
            this.customer.country = ''
            this.customer.name = ''
            this.customer.extraOrderMail = ''

            this.$notify({group: 'success', type: 'success', title: 'Succes', text: 'Klant is aangemaakt!'})
            this.$modal.hide('add-customer-modal')
          } else {
            this.$notify({group: 'danger', type: 'error', title: 'Error', text: 'Klant is niet aangemaakt!'})
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        isCustomerCreated: 'isCustomerCreated'
      })
    }
  }
</script>

<style scoped>
  .mb-20 {
    margin-bottom: 20px;
  }
</style>
